import { useEffect } from "react";
import AppRouter from "./router/AppRouter";

function App() {
  useEffect(() => {
    document.documentElement.classList.remove("light", "dark");
    document.body.classList.remove("light", "dark");
    document.documentElement.classList.add("light");
    document.body.classList.add("light");
  }, []);

  return <AppRouter />;
}

export default App;
